import { RecurrenceValues } from 'src/Hooks/Forms/UseCreateEventForm/useCreateEventForm.types';
import parseIntSafe from 'src/Services/Shared/parseIntSafe';

export const handleMonthlyRecurrence = (values: RecurrenceValues) => {
  if (values.monthDayNumberOrAdvanced === 'number') {
    return {
      byMonthDay: values.byMonthDays.map(parseIntSafe),
    };
  }

  if (values.byWeekDay === '') {
    return {
      byMonthDay: [parseIntSafe(values.byMonthDay)],
    };
  }

  return {
    byWeekDay: [parseIntSafe(values.byWeekDay)],
    bySetPos: parseIntSafe(values.byMonthDay),
  };
};
